import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { initializeGoogleAuth } from './plugins/googleAuth';
import { Capacitor } from '@capacitor/core';

// Service worker registration - only for web, not Capacitor
let serviceWorkerRegistration = null;
if (!Capacitor.isNativePlatform()) {
  serviceWorkerRegistration = require('./serviceWorkerRegistration');
}

// Initialize Google Auth for native platforms
if (Capacitor.isNativePlatform()) {
  initializeGoogleAuth();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// Only unregister service worker on web platform
if (serviceWorkerRegistration) {
  serviceWorkerRegistration.unregister();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
